import { NgModule } from '@angular/core';
import { ToSystemTimePipe } from './to-system-time.pipe';

@NgModule({
  declarations: [ToSystemTimePipe],
  exports: [ToSystemTimePipe],
})
export class ToSystemTimeModule {}
